/* MM desktop dropdown helpers (see snippets/mm-dropdown-promos.liquid). */
(() => {
  if (window.mmDropdownInit) return;
  window.mmDropdownInit = true;

  const desktop = window.matchMedia('(min-width: 1100px)');

  // Line the dropdown columns up with the first item of the inline menu.
  const setIndent = () => {
    const section = document.querySelector('.shopify-section-header');
    const wrapper = document.querySelector('.header-wrapper');
    const item = document.querySelector('.header__inline-menu .list-menu-item');
    if (!section || !wrapper || !item) return;
    const target = item.querySelector('.list-menu-line, .header__menu-item span, .header__menu-item') || item;
    const x = target.getBoundingClientRect().left - wrapper.getBoundingClientRect().left;
    if (x > 0) section.style.setProperty('--mm-dd-indent', `${Math.round(x)}px`);
  };

  let indentFrame;
  const queueIndent = () => {
    cancelAnimationFrame(indentFrame);
    indentFrame = requestAnimationFrame(setIndent);
  };

  // Start loading dropdown images as soon as the visitor reaches the menu.
  const warmImages = () => {
    document.querySelectorAll('.mm-dd img[loading="lazy"]').forEach((img) => {
      img.loading = 'eager';
    });
  };

  const inMenu = (event) => event.target instanceof Element && event.target.closest('.header__inline-menu');

  document.addEventListener(
    'pointerover',
    (event) => {
      if (!inMenu(event)) return;
      warmImages();
      queueIndent();
    },
    { passive: true }
  );

  document.addEventListener('focusin', (event) => {
    if (inMenu(event)) warmImages();
  });

  // Hover dropdowns: close when the pointer moves onto the blurred page.
  document.addEventListener(
    'mouseover',
    (event) => {
      if (!desktop.matches || !(event.target instanceof Element)) return;
      const overlay = event.target.closest('.burger-menu__overlay--active');
      if (!overlay) return;
      const menu = overlay.closest('burger-menu');
      if (!menu || menu.dataset.openOnHover !== 'true' || menu.dataset.mmPinned === 'true') return;
      if (!menu.querySelector('[data-mm-dd]') || typeof menu.close !== 'function') return;
      menu.close(new Event('mouseleave'));
    },
    { passive: true }
  );

  // Theme editor: show the dropdown while its Mega menu block is selected.
  const findMenu = (blockId) => {
    if (!blockId) return null;
    const dd = [...document.querySelectorAll('[data-mm-dd]')].find((el) => el.dataset.mmDd === blockId);
    return dd ? dd.closest('burger-menu') : null;
  };

  const isOpen = (menu) => !!menu.querySelector('.burger-menu.burger-menu--open');

  document.addEventListener('shopify:block:select', (event) => {
    const menu = findMenu(event.detail && event.detail.blockId);
    if (!menu || typeof menu.open !== 'function') return;
    menu.dataset.mmPinned = 'true';
    setIndent();
    warmImages();
    if (!isOpen(menu)) menu.open(new Event('click'));
  });

  document.addEventListener('shopify:block:deselect', (event) => {
    const menu = findMenu(event.detail && event.detail.blockId);
    if (!menu) return;
    delete menu.dataset.mmPinned;
    if (isOpen(menu) && typeof menu.close === 'function') menu.close(new Event('click'));
  });

  document.addEventListener('shopify:section:load', queueIndent);
  window.addEventListener('resize', queueIndent, { passive: true });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(queueIndent);
  setIndent();
})();
